import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import PanelDev from '../panels/dev/PanelDev';

import PanelMain from '../panels/main/PanelMain';

export default function LayoutHome() {

    const [isOpen, setIsOpen] = useState(true);

    const { page } = useParams();

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    }

    return (
        <>
            <div className='h-screen w-full'>
                {
                    (() => {
                        switch (page) {
                            case 'main':
                                return (<PanelMain onToggle={toggleMenu} />);
                            default:
                                return (<PanelDev />);
                        }
                    })()
                }
            </div>
        </>
    )
}
